import React from "react";
import {
  Box,
  Container,
  useMediaQuery,
  useTheme,
  Grid,
  Typography,
} from "@mui/material";

import BigDataImage from "@/assets/imgs/products/big_data_bg.png";
const BigData: React.FC = () => {
  return (
    <Box>
      <Container className="" maxWidth="xl">
        <Box className="product-content-box">
          <Grid container className="infuser-descgrid" spacing={3}>
            <Grid item xs={12} sm={8} md={7} lg={7}>
              <Box className="infuser-desc-box">
                <Box className="infuser-desc-title">빅데이터란?</Box>
                <Box className="infuser-desc-row">
                  <Typography className="infuser-desc-sub">
                    빅데이터의 &nbsp;
                  </Typography>
                  <Typography className="infuser-desc-sub bold-word">
                    수집, 관리, 분석 및 <br />
                  </Typography>
                  <Typography className="infuser-desc-sub bold-word">
                    AI를 활용한 최신 기술을 보유
                  </Typography>
                  <Typography className="infuser-desc-sub">
                    한 솔루션입니다.
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Box className="infuser-desc-box pb-100 pt-100">
              <img src={BigDataImage} className="big-data-bg-img" />
            </Box>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default BigData;
